import React from 'react';
import ReactDOM from 'react-dom';

import ConnectedBriefApp from 'contest/components/connected/connected-brief-app';
import BriefStore from 'contest/stores/brief-store';
import TooltipStore from 'contest/stores/TooltipStore';

import briefLoadAction from 'contest/actions/brief-load';
import { Fluxible } from 'fluxible';
import { IntlProvider } from 'react-intl';
import { FluxibleComponent } from 'fluxible-addons-react';

import { DragAndDrop } from 'fine-uploader/s3.fine-uploader/s3.fine-uploader';

document.addEventListener('DOMContentLoaded', () => {
    // For highlighting all dropzones when dragging into window
    new DragAndDrop({
        classes: {
            dropActive: 'dropzone-highlight-targets',
        },
        dropZoneElements: [document.body],
    });

    const app = new Fluxible();
    app.registerStore(BriefStore);
    app.registerStore(TooltipStore);
    const context = app.createContext();
    const actionContext = context.getActionContext();

    const appNode = document.querySelector('[data-brief-data]');

    const intlData = JSON.parse(appNode.getAttribute('data-brief-translations'));
    const appState = JSON.parse(appNode.getAttribute('data-brief-state'));

    actionContext.getStore(TooltipStore).load({
        tooltips: appState.tooltips,
        intlData,
    });
    actionContext.executeAction(briefLoadAction, appState, () => {
        ReactDOM.render(
            <FluxibleComponent context={context.getComponentContext()}>
                <IntlProvider locale={intlData.locale} messages={intlData.messages}>
                    <ConnectedBriefApp />
                </IntlProvider>
            </FluxibleComponent>,
            document.querySelector('[data-versioned-brief]')
        );
    });
});



// WEBPACK FOOTER //
// ./src/web/js/contest/brief.jsx